document.addEventListener('DOMContentLoaded', () => {
    MAIN.onReady();
    TRACKING.onReady();
});

const MAIN = {
    onReady() {
        ACCORDEON.onReady();
        BLOG.onReady();
        CLEAN.onReady();
        DROPDOWN.onReady();
        FORM.onReady();
        SEARCH.onReady();
        MAPS.onReady();
        NAV.onReady();
        OVERLAY.onReady();
        TINYSLIDER.onReady();
        TOOLTIP.onReady();
    }
}